import React, { useEffect } from 'react';
import styled from 'styled-components';
import {
  WidgetPrintHeader,
  Container,
  BodyPrint,
} from '@mummssoftware/common-ui';
import { OrdersTable } from '../Orders/OrdersTable';
import defaults from '../../translations/en.json';

// way to get next page break with global printing
const PageBreak = styled.div`
  @media print {
    visibility: hidden;
  }
`;

type OrdersPrintProps = {
  orders: mumms.Order[];
  onWidgetReady?: (arg: mumms.ComponentName) => void;
};

export const OrdersPrint = ({ orders, onWidgetReady }: OrdersPrintProps) => {
  // on component did mount
  useEffect(() => {
    // callback to alert dashboard the view is ready
    onWidgetReady && onWidgetReady('Orders' as mumms.ComponentName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <BodyPrint id="print-assistance">
        <WidgetPrintHeader title={defaults.title} />
        <OrdersTable viewModePrint smallWidget={false} />
      </BodyPrint>
      <PageBreak />
    </Container>
  );
};
